// src/utils/env.js
// Environment configuration utilities with safe fallbacks

/**
 * Get the backend base URL with safe fallback logic
 * Returns URL without trailing slash
 *
 * Priority:
 * 1. REACT_APP_BACKEND_URL (if set)
 * 2. REACT_APP_API_URL with /api stripped
 * 3. http://localhost:8000 (dev fallback)
 *
 * @returns {string} Backend base URL without trailing slash
 */
export const getBackendBase = () => {
  // First try explicit BACKEND_URL
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  if (backendUrl) {
    return backendUrl.replace(/\/+$/, ''); // Remove trailing slashes
  }

  // Derive from API_URL by stripping /api or /api/
  const apiUrl = process.env.REACT_APP_API_URL;
  if (apiUrl) {
    const normalized = apiUrl
      .replace(/\/api\/?$/, '') // Remove /api or /api/ from end
      .replace(/\/+$/, '');     // Remove any remaining trailing slashes

    if (process.env.NODE_ENV === 'development') {
      console.warn(
        '[ENV] REACT_APP_BACKEND_URL not set, derived from REACT_APP_API_URL:',
        normalized
      );
    }

    return normalized;
  }

  // Final fallback for local development
  if (process.env.NODE_ENV === 'development') {
    console.warn('[ENV] No backend URL configured, using localhost fallback');
  }

  return 'http://localhost:8000';
};

/**
 * Get the full Google OAuth redirect URI
 * @returns {string} Full URL to backend Google OAuth endpoint
 */
export const getGoogleOAuthRedirectUri = () => {
  const base = getBackendBase();
  return `${base}/api/auth/social/google/`;
};
